type GlobalErrorHandler = (message: string, status?: number) => void;

import { ToastContainer, toast } from 'react-toastify';

let globalErrorHandler: GlobalErrorHandler | null = null;

export const registerGlobalErrorHandler = (handler: GlobalErrorHandler) => {
  globalErrorHandler = handler;
};

const sha1 = (message: string) => { // MODIFIED: Added type for message
  const textEncoder = new TextEncoder();
  const data = textEncoder.encode(message);
  // Note: crypto.subtle.digest returns a Promise, this function should ideally be async
  // For now, keeping it as is to avoid cascading changes, but it's a potential area for improvement.
  const hashBuffer = crypto.subtle.digest('SHA-1', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hexHash = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hexHash;

}

export const displayGlobalError = (message: string, status?: number) => {
  
  const tMessage = `API Error: ${message} (Status: ${status || 'N/A'})\nContact Us at ${process.env.REACT_APP_SUPPORT_EMAIL}`;
  // Note: sha1 is not awaited here, which might lead to a Promise being passed as toastId.
  // This is a pre-existing condition and not introduced by the current changes.
  const tId = sha1(tMessage);

  toast(tMessage, {
    className: 'bg-orange-300',
    autoClose: 15000,
    pauseOnFocusLoss: true,
    toastId: tId
  });

  return;
  if (globalErrorHandler) {
    globalErrorHandler(message, status);
  } else {
    console.error("Global error handler not registered. Error:", message, "Status:", status);
    // Fallback to a simple alert or console log if the handler isn't ready
    alert(`API Error: ${message} (Status: ${status || 'N/A'})`);

  }
};